<template>
  <v-card class="PresentationPermissionsCard mb-4">
    <v-card-title>
      Permissions
    </v-card-title>
    <v-simple-table>
      <tbody>
      <tr>
        <td>
          A Mobile Locker user
        </td>
        <td>
          <v-list dense
                  class="py-0">
            <presentation-permission-list-item v-if="1===2 && team.is_content_domain_enabled"
                                               :presentation="presentation"
                                               :permission="presentation.settings.can_user_use_cdn"
                                               can="view this file in a browser">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_presented_by_user"
                                               can="present this file from the browser">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_shared"
                                               can="share this file as a link via email">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_shared_link"
                                               can="create a link to this file that can be shared elsewhere">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_exported"
                                               can="export this file from the browser or desktop app">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_printed_by_user"
                                               can="print this file from the browser or desktop app">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_annotated"
                                               can="annotate this file in the iOS app">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.is_rateable"
                                               can="rate this file in the iOS app">
            </presentation-permission-list-item>
          </v-list>
        </td>
      </tr>
      <tr v-if="team.sharing_enabled">
        <td>
          A viewer of the shared link
        </td>
        <td>
          <v-list dense
                  class="py-0">
            <presentation-permission-list-item v-if="team.is_content_domain_enabled"
                                               :presentation="presentation"
                                               :permission="presentation.settings.can_share_cdn_link"
                                               can="view this file in a browser">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_downloaded"
                                               can="download this file">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_printed"
                                               can="print this file">
            </presentation-permission-list-item>
            <presentation-permission-list-item :presentation="presentation"
                                               :permission="presentation.settings.can_be_forwarded"
                                               can="forward this file to someone else">
            </presentation-permission-list-item>
          </v-list>
        </td>
      </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<style lang="scss">
.PresentationPermissionsCard {
  .v-list {
    background: none;
  }
}
</style>
<script>
import {mapGetters} from 'vuex';
import PresentationPermissionListItem from './PresentationPermissionListItem';

export default {
  components: {PresentationPermissionListItem},
  props: {
    presentation: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
  },
  methods: {
    canBe(permission) {
      return this.presentation.settings[`can_be_${permission}`];
    },
  }
}
</script>
